(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["archive-tracklist"] && !Shopify.designMode) return;
  try {
    document.addEventListener('play', event => {
  if (!event.target.matches('.archive-track-audio')) return;
  document.querySelectorAll('audio').forEach(audio => { if (audio !== event.target) audio.pause(); });
}, true);
document.addEventListener('ended', event => {
  if (!event.target.matches('.archive-track-audio')) return;
  const list = event.target.closest('.archive-tracklist');
  const tracks = Array.from(list.querySelectorAll('.archive-track-audio'));
  const next = tracks[tracks.indexOf(event.target) + 1];
  if (next) next.play().catch(() => {});
}, true);
  } catch(e) { console.error(e); }
})();

})();
